const printContent = ({printSectionHtml, optionsCss = {}, titulo = 'Imprimir', width = 800, height = 600}) =>{  
    const printWindow = window.open('', '', `width=${width},height=${height}`);
  
    printWindow.document.write(`
      <html>
        <head>
          <title>${titulo}</title>
          <style>${optionsCss}</style>
        </head>
        <body>
          ${printSectionHtml}
        </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  }
export default { printContent }